<script>
	export let data = {};

	let src = "";
	$: {
		if (data.service === "Youtube") {
			src = `https://www.youtube.com/embed/${data.videoId}?rel=0&loop=1&playlist=${data.videoId}`;
		} else if (data.service === "Vimeo") {
			src = `https://player.vimeo.com/video/${data.videoId}?title=0&byline=0&portrait=0&loop=1`;
		} else {
			src = "";
		}
	}
</script>

<div class="UIVideo">
	{#if src}
		<div>
			<iframe
				{src}
				title="video player"
				width="640"
				height="360"
				frameborder="0"
				allowfullscreen
			/>
		</div>
	{/if}
	{#if data.caption}
		<p class="UIVideo-caption">{data.caption}</p>
	{/if}
</div>

<style global>
	.UIVideo {
		padding: 1em 0;
		position: relative;
		max-width: 1024px;
		margin: 0 auto;
	}
	.UIVideo > div {
		position: relative;
		height: 0;
		padding: 0 0 56.25%;
		overflow: hidden;
	}
	.UIVideo iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		vertical-align: bottom;
	}
	.UIVideo-caption {
		font-size: 0.8em;
		color: #888;
		padding: 0.25em 0 0;
	}
</style>
